import { Link } from '@tanstack/react-router';
import { Check, Play, Lock, MonitorPlay } from 'lucide-react';

import type { AnnotatedTopic } from './learnModel';

/** Small "has an animation" affordance, so the good topics are discoverable. */
function VizBadge() {
  return (
    <span
      className="inline-flex shrink-0 items-center gap-1 rounded-full bg-[#fff3ee] px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-[#ff5a1f]"
      title="Includes an interactive walkthrough"
    >
      <MonitorPlay className="size-3" />
      Visual
    </span>
  );
}

export function LearnTopicRow({
  batchId,
  annotated,
}: {
  batchId: string;
  annotated: AnnotatedTopic;
}) {
  const { topic, state } = annotated;

  if (state === 'locked') {
    return (
      <div aria-disabled="true" className="flex cursor-not-allowed items-start gap-3 rounded-[14px] px-4 py-2.5">
        <span className="flex size-6 shrink-0 items-center justify-center">
          <Lock className="size-3.5 text-[#9ca3af]" />
        </span>
        <span className="min-w-0">
          <span className="block text-sm font-medium text-[#9ca3af]">{topic.title}</span>
          {topic.subtitle && <span className="mt-0.5 block text-xs text-[#c4c4c4]">{topic.subtitle}</span>}
        </span>
      </div>
    );
  }

  const Icon = state === 'completed' ? Check : Play;
  return (
    <Link
      to="/courses/$batchId/topics/$topicId"
      params={{ batchId, topicId: topic.id }}
      className="flex items-start gap-3 rounded-[14px] px-4 py-2.5 transition-colors hover:bg-white"
    >
      <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-full bg-[#8b5cf6]">
        <Icon className={`text-white ${state === 'completed' ? 'size-3' : 'size-2.5 translate-x-px fill-white'}`} />
      </span>
      <span className="min-w-0">
        <span className="flex flex-wrap items-center gap-2">
          <span className="text-sm font-medium text-[#111827]">{topic.title}</span>
          {state === 'next' && (
            <span className="rounded-full bg-[#ede9fe] px-2 py-0.5 text-xs font-semibold text-[#8b5cf6]">Next</span>
          )}
          {topic.has_visualization && <VizBadge />}
        </span>
        {/* The one-line "why" — the difference between a timetable and a promise. */}
        {topic.subtitle && <span className="mt-0.5 block text-xs text-[#6b7280]">{topic.subtitle}</span>}
      </span>
    </Link>
  );
}
